import { useMemo } from "react";

import { EmailType } from "@interfaces/campaign.type";

export type StatusesType = "clicked" | "opened" | "responded";

const useFilteredEmails = (emails: EmailType[], activeSection: StatusesType) => {
  return useMemo(() => {
    switch (activeSection) {
      case "clicked": {
        return emails.filter((email) => email.linkClicked);
      }
      case "opened": {
        return emails.filter((email) => email.opened);
      }
      case "responded": {
        return emails.filter((email) => email.replyReceived);
      }
      default: {
        return emails;
      }
    }
  }, [activeSection, emails]);
};

export default useFilteredEmails;
